/**
 * AGB (Terms of Service) — German content.
 *
 * IMPORTANT: This is the legally binding version. If you change anything here,
 * update AGBContentEn.tsx accordingly. The German text prevails in case of conflicts.
 *
 * Last updated: 2026-04-21 | Version: 1.3
 */

import { Link } from "react-router-dom";

export function AGBContentDe() {
  return (
    <>
      <p>
        <strong>Geltungsbereich:</strong> Equna App und Website
      </p>
      <p>
        <strong>Betreiber:</strong><br />
        <strong>Patrizio Veglia</strong><br />
        Herbststr. 9<br />
        13409 Berlin, Germany
      </p>
      <p>E-Mail: contact@equna.eu</p>

      <hr />

      <h2>1. Geltungsbereich und Vertragspartner</h2>

      <h3>1.1 Geltungsbereich</h3>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der Equna App und Website (nachfolgend „Dienst" genannt).
      </p>

      <h3>1.2 Vertragspartner</h3>
      <p>Der Vertrag über die Nutzung des Dienstes kommt zustande zwischen:</p>
      <ul>
        <li><strong>Anbieter:</strong> Patrizio Veglia, Herbststr. 9, 13409 Berlin</li>
        <li><strong>Nutzer:</strong> Die Person, die sich bei Equna registriert</li>
      </ul>

      <h3>1.3 Vertragssprache</h3>
      <p>Die Vertragssprache ist Deutsch.</p>

      <hr />

      <h2>2. Registrierung und Vertragsschluss</h2>

      <h3>2.1 Registrierung</h3>
      <p>
        Die Nutzung des Dienstes erfordert eine Registrierung. Bei der Registrierung müssen Sie folgende Daten angeben:
      </p>
      <ul>
        <li>E-Mail-Adresse (muss gültig sein)</li>
        <li>Passwort (min. 12 Zeichen)</li>
        <li>Anzeigename (frei wählbar)</li>
      </ul>

      <h3>2.2 Vertragsschluss</h3>
      <p>Der Vertrag kommt zustande, wenn Sie:</p>
      <ol>
        <li>Das Registrierungsformular vollständig ausfüllen</li>
        <li>Die Datenschutzerklärung und AGB akzeptieren</li>
        <li>Auf „Registrieren" klicken</li>
        <li>Ihre E-Mail-Adresse bestätigen (Verifizierungs-Link)</li>
      </ol>

      <h3>2.3 Mindestalter</h3>
      <p>
        Die Nutzung des Dienstes ist <strong>nur Personen ab 16 Jahren</strong> gestattet. Bei Personen zwischen 16 und 18 Jahren ist die Einwilligung der Erziehungsberechtigten erforderlich.
      </p>

      <hr />

      <h2>3. Leistungen des Anbieters</h2>

      <h3>3.1 Free-Tier (kostenlos)</h3>
      <p>
        Der Dienst wird in einer kostenlosen Basisversion angeboten („Free-Tier") mit folgenden Funktionen:
      </p>

      <p><strong>Ausgabenverwaltung:</strong></p>
      <ul>
        <li>Verwaltung von gemeinsamen Ausgaben (Shared Expenses)</li>
        <li>Verwaltung von Kinderausgaben (Child Expenses)</li>
        <li>Verwaltung von persönlichen Ausgaben (Personal Expenses, lokal gespeichert)</li>
        <li>Kategorisierung von Ausgaben</li>
      </ul>

      <p><strong>Budgetverwaltung:</strong></p>
      <ul>
        <li>Monatsbudgets festlegen</li>
        <li>Kategorie-Budgets definieren</li>
        <li>Budget-Fortschrittsanzeige</li>
      </ul>

      <p><strong>Übersichten &amp; Analysen:</strong></p>
      <ul>
        <li>Monatsübersichten mit Saldenberechnung</li>
        <li>Jahresübersicht mit Monatsvergleich</li>
        <li>Kategorien-Analyse mit Diagrammen</li>
        <li>Ausgleichsberechnungen (wer schuldet wem)</li>
      </ul>

      <p><strong>Gruppen &amp; Zusammenarbeit:</strong></p>
      <ul>
        <li>Gruppeneinladungen per Link (24 Stunden gültig)</li>
        <li>Monatsabschluss mit Partner-Bestätigung</li>
        <li>Benachrichtigungen (In-App)</li>
      </ul>

      <p><strong>Weitere Features:</strong></p>
      <ul>
        <li>Receipt-Fotos hochladen (Cloud-Speicherung)</li>
        <li>Kinder-Profile verwalten</li>
        <li>Tutorial-System für neue Nutzer</li>
        <li>Datenexport im JSON-Format (DSGVO-konform)</li>
      </ul>

      <h3>3.2 Premium-Tier (kostenpflichtig)</h3>
      <p>
        Der Dienst kann in Zukunft gegen Entgelt als Premium-Version angeboten werden mit erweiterten Funktionen:
      </p>
      <ul>
        <li><strong>Unbegrenzte Echtzeit-Updates</strong> (keine Verzögerung)</li>
        <li><strong>Budget-Frühwarnungen</strong> (bei 80% und 90% des Budgets)</li>
        <li><strong>Custom Budget-Schwellenwerte</strong> (individuelle Warngrenzen)</li>
        <li><strong>Budget-Gruppen</strong> (mehrere Kategorien zu Gruppen zusammenfassen, z.B. „Fixkosten")</li>
        <li><strong>Erweiterte Zeitraum-Filter</strong> (individuelle Zeiträume in der Analyse)</li>
        <li><strong>Receipt-Aufbewahrung</strong> (365 Tage statt 60 Tage im Free-Tier)</li>
        <li><strong>HTML-Datenexport</strong> (formatiert, druckbar)</li>
        <li><strong>Erweiterte Datenansicht</strong> (Premium DSGVO-View)</li>
      </ul>
      <p><strong>Preise und Konditionen:</strong> Werden bei Einführung des Premium-Tiers bekanntgegeben. Nutzer werden rechtzeitig per E-Mail und In-App-Benachrichtigung informiert.</p>

      <h3>3.3 Verfügbarkeit</h3>
      <p>
        Der Anbieter bemüht sich um eine hohe Verfügbarkeit des Dienstes (angestrebtes Ziel: 99% Uptime). Es besteht jedoch <strong>kein Anspruch</strong> auf eine bestimmte Verfügbarkeit.
      </p>
      <p>
        <strong>Wartungsarbeiten:</strong> Der Anbieter kann den Dienst für Wartungsarbeiten temporär unterbrechen. Geplante Wartungen werden nach Möglichkeit im Voraus angekündigt.
      </p>

      <hr />

      <h2>4. Pflichten und Verantwortlichkeiten des Nutzers</h2>

      <h3>4.1 Korrekte Angaben</h3>
      <p>
        Der Nutzer verpflichtet sich, bei der Registrierung und Nutzung <strong>korrekte und vollständige Angaben</strong> zu machen.
      </p>

      <h3>4.2 Geheimhaltung der Zugangsdaten</h3>
      <p>
        Der Nutzer ist verpflichtet, seine Zugangsdaten (Passwort) <strong>geheim zu halten</strong> und vor dem Zugriff Dritter zu schützen.
      </p>
      <p>
        <strong>Bei Verdacht auf Missbrauch:</strong> Nutzer muss den Anbieter unverzüglich informieren und sein Passwort ändern.
      </p>

      <h3>4.3 Verbotene Nutzung</h3>
      <p>
        Der Nutzer verpflichtet sich, den Dienst <strong>nicht zu missbrauchen</strong>. Verboten sind insbesondere:
      </p>
      <ul>
        <li><strong>Illegale Inhalte:</strong> Hochladen oder Teilen rechtswidriger Inhalte</li>
        <li><strong>Belästigung:</strong> Beleidigung, Bedrohung oder Belästigung anderer Nutzer</li>
        <li><strong>Spam:</strong> Versenden unerwünschter Nachrichten oder Einladungen</li>
        <li><strong>Hacking:</strong> Versuche, den Dienst zu manipulieren oder unbefugten Zugriff zu erlangen</li>
        <li><strong>Bots/Automatisierung:</strong> Nutzung von Bots oder automatisierten Tools ohne Zustimmung</li>
        <li><strong>Reverse Engineering:</strong> Dekompilierung oder Deassemblierung der App</li>
      </ul>

      <h3>4.4 Haftung für Inhalte</h3>
      <p>
        Der Nutzer ist allein verantwortlich für die von ihm hochgeladenen Inhalte (Ausgaben, Kommentare, Receipt-Fotos, etc.). Der Anbieter prüft diese Inhalte <strong>nicht</strong> vorab.
      </p>
      <p>
        Dies gilt insbesondere für Daten, die <strong>Dritte</strong> (z.B. Partner, Kinder) betreffen: Der Nutzer stellt sicher, dass er zur Speicherung solcher Daten berechtigt ist, und verzichtet darauf, sensible Daten (insbesondere Gesundheits-, Religions- oder Sozialdaten von Kindern) in Freitextfelder einzugeben.
      </p>

      <hr />

      <h2>5. Gruppen und geteilte Daten</h2>

      <h3>5.1 Gruppen-Funktionalität</h3>
      <p>
        Nutzer können einer Gruppe beitreten, um Ausgaben gemeinsam zu verwalten. Innerhalb einer Gruppe sind <strong>geteilte Ausgaben und Kinderausgaben</strong> für alle Gruppenmitglieder sichtbar. Persönliche Ausgaben bleiben privat und werden ausschließlich lokal auf dem Gerät des Nutzers gespeichert.
      </p>

      <h3>5.2 Einwilligung zur Datenteilung</h3>
      <p>
        Mit dem Beitritt zu einer Gruppe willigt der Nutzer ein, dass seine geteilten Ausgaben und Kinderausgaben für andere Gruppenmitglieder sichtbar sind. Diese Einwilligung kann durch Verlassen der Gruppe widerrufen werden.
      </p>

      <h3>5.3 Verantwortung bei Gruppenverlassen</h3>
      <p>
        Beim Verlassen einer Gruppe werden bereits erfasste geteilte Ausgaben <strong>nicht automatisch gelöscht</strong>, um die Datenintegrität für verbleibende Gruppenmitglieder zu gewährleisten. Der Name des ausgetretenen Nutzers kann auf Wunsch anonymisiert werden.
      </p>

      <h3>5.4 Streitigkeiten zwischen Nutzern</h3>
      <p>
        Der Anbieter ist <strong>nicht Partei</strong> bei Streitigkeiten zwischen Gruppenmitgliedern über Ausgaben, Verteilungsschlüssel oder Abrechnungen. Die App dient lediglich als Dokumentationswerkzeug. Rechtliche Ansprüche zwischen Nutzern (z.B. zwischen Partnern oder Co-Eltern) sind außerhalb der App zu klären.
      </p>

      <hr />

      <h2>6. Haftungsbeschränkung</h2>

      <h3>6.1 Haftung bei Vorsatz und grober Fahrlässigkeit</h3>
      <p>
        Der Anbieter haftet <strong>unbeschränkt</strong> für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie bei Vorsatz und grober Fahrlässigkeit.
      </p>

      <h3>6.2 Haftung bei leichter Fahrlässigkeit</h3>
      <p>
        Bei leichter Fahrlässigkeit haftet der Anbieter <strong>nur</strong> bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten). Die Haftung ist in diesem Fall auf den <strong>vorhersehbaren, vertragstypischen Schaden</strong> begrenzt.
      </p>

      <h3>6.3 Ausschluss der Haftung</h3>
      <p>
        <strong>Soweit gesetzlich zulässig</strong> und unter Berücksichtigung der in § 6.1 und § 6.2 geregelten Haftungsfälle haftet der Anbieter nicht für:
      </p>
      <ul>
        <li><strong>Datenverlust:</strong> Sofern dieser durch angemessene Datensicherungsmaßnahmen des Nutzers vermeidbar gewesen wäre</li>
        <li><strong>Persönliche Ausgaben:</strong> Diese werden ausschließlich lokal auf dem Gerät des Nutzers gespeichert und nicht auf unseren Servern gesichert</li>
        <li><strong>Indirekte Schäden, entgangener Gewinn, Folgeschäden</strong> — soweit diese nicht auf Vorsatz, grober Fahrlässigkeit oder der Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) beruhen</li>
        <li><strong>Höhere Gewalt:</strong> Ausfälle durch Naturkatastrophen, Streik, Krieg, etc.</li>
        <li><strong>Drittanbieter:</strong> Ausfälle durch externe Dienstleister (Hosting, Cloud-Speicher)</li>
      </ul>
      <p className="text-sm text-slate-500">
        Die Regelungen in § 6.1 (Vorsatz, grobe Fahrlässigkeit, Körperschäden) und § 6.2 (Kardinalpflichten) bleiben unberührt.
      </p>

      <h3>6.4 Keine Finanzberatung</h3>
      <p>
        Der Dienst dient ausschließlich der <strong>persönlichen Ausgabenverfolgung</strong>. Er stellt <strong>keine Steuerberatung, Finanzberatung oder Rechtsberatung</strong> dar. Für steuerliche oder rechtliche Fragen wenden Sie sich bitte an einen qualifizierten Berater.
      </p>

      <h3>6.5 Datensicherung</h3>
      <p>
        <strong>Serverseitige Backups:</strong> Der Anbieter führt regelmäßige Datensicherungen der auf unseren Servern gespeicherten Daten durch (gemeinsame Ausgaben, Kinderausgaben, Budgets, Kontodaten). Es wird jedoch <strong>keine Garantie</strong> für die vollständige Wiederherstellbarkeit von Daten übernommen.
      </p>
      <p>
        <strong>Persönliche Ausgaben:</strong> Diese werden <strong>ausschließlich lokal</strong> auf dem Gerät des Nutzers gespeichert und sind <strong>nicht</strong> in den serverseitigen Backups enthalten. Der Nutzer ist selbst verantwortlich für die Sicherung dieser Daten.
      </p>
      <p>
        <strong>Export-Funktion:</strong> Der Anbieter stellt eine Export-Funktion bereit (Profil &rarr; „Datenauskunft &amp; Export"), mit der Nutzer ihre Daten jederzeit sichern können.
      </p>

      <hr />

      <h2>7. Gewährleistung</h2>

      <h3>7.1 Free-Tier</h3>
      <p>
        Für den kostenlosen Free-Tier gilt: Der Dienst wird „<strong>as is</strong>" (wie gesehen) bereitgestellt. <strong>Keine Gewährleistung</strong> für Fehlerfreiheit, Verfügbarkeit oder Eignung für bestimmte Zwecke.
      </p>

      <h3>7.2 Premium-Tier</h3>
      <p>
        Für den Premium-Tier gilt: Der Anbieter gewährleistet, dass der Dienst im Wesentlichen der Leistungsbeschreibung entspricht. Unwesentliche Abweichungen berechtigen <strong>nicht</strong> zur Minderung oder Kündigung.
      </p>
      <p>
        <strong>Mängelbehebung:</strong> Bei Mängeln hat der Anbieter das Recht zur Nachbesserung. Erst nach erfolgloser Nachbesserung kann der Nutzer mindern oder kündigen.
      </p>

      <h3>7.3 Aktualisierungspflicht (§ 327f BGB)</h3>
      <p>
        Soweit es sich bei Equna um ein digitales Produkt im Sinne der §§ 327 ff. BGB handelt, stellt der Anbieter die für den Erhalt der Vertragsmäßigkeit erforderlichen Aktualisierungen — <strong>insbesondere Sicherheits-Updates</strong> — für den Zeitraum bereit, der nach Art und Zweck des digitalen Produkts erwartbar ist. Funktionale Erweiterungen stehen im Ermessen des Anbieters.
      </p>
      <p>
        Der Nutzer ist verpflichtet, ihm angebotene Updates innerhalb einer angemessenen Frist zu installieren. Unterlässt der Nutzer dies, haftet der Anbieter nicht für Mängel, die allein auf der fehlenden Aktualisierung beruhen — vorausgesetzt, der Anbieter hat über das Update und die Folgen einer unterbliebenen Installation informiert.
      </p>

      <hr />

      <h2>8. Vertragslaufzeit und Kündigung</h2>

      <h3>8.1 Free-Tier</h3>
      <p>
        Der Vertrag läuft auf <strong>unbestimmte Zeit</strong>. Beide Parteien können <strong>jederzeit ohne Frist</strong> kündigen.
      </p>
      <p>
        <strong>Kündigung durch Nutzer:</strong> Profil &rarr; „Konto löschen" &rarr; Sicherheitsbestätigung
      </p>
      <p>
        <strong>Kündigung durch Anbieter:</strong> Per E-Mail mit Frist von 14 Tagen (nur bei Verstoß gegen AGB ohne Frist)
      </p>

      <h3>8.2 Premium-Tier</h3>
      <p>Das Premium-Tier befindet sich in Planung. Die folgenden Konditionen werden bei Einführung finalisiert:</p>
      <p>[Wird bei Einführung des Premium-Tiers ergänzt]</p>
      <p>Voraussichtlich:</p>
      <ul>
        <li>Monatliche oder jährliche Laufzeit</li>
        <li>Kündigung zum Ende der Laufzeit möglich</li>
        <li>Kündigungsfrist: 14 Tage vor Ablauf</li>
      </ul>

      <h3>8.3 Außerordentliche Kündigung</h3>
      <p>Der Anbieter kann den Vertrag <strong>fristlos kündigen</strong>, wenn:</p>
      <ul>
        <li>Der Nutzer gegen diese AGB verstößt (siehe § 4.3)</li>
        <li>Der Nutzer den Dienst missbraucht</li>
        <li>Zahlungsrückstände bestehen (Premium-Tier)</li>
      </ul>

      <hr />

      <h2>9. Datenschutz</h2>

      <p>
        Für die Verarbeitung personenbezogener Daten gilt unsere <strong>Datenschutzerklärung</strong>, die Sie hier einsehen können:
      </p>
      <p>
        <strong>Link:</strong>{" "}
        <Link to="/datenschutz" className="text-blue-600 hover:text-blue-800 underline">
          https://equna.eu/datenschutz
        </Link>
      </p>
      <p>
        Durch Nutzung des Dienstes stimmen Sie der Datenverarbeitung gemäß Datenschutzerklärung zu.
      </p>

      <hr />

      <h2>10. Änderungen der AGB</h2>

      <h3>10.1 Änderungsrecht</h3>
      <p>
        Der Anbieter behält sich vor, diese AGB zu ändern. Änderungen werden den Nutzern <strong>mindestens 4 Wochen</strong> vor Inkrafttreten per E-Mail mitgeteilt.
      </p>

      <h3>10.2 Unterscheidung nach Art der Änderung</h3>
      <p>
        <strong>Wesentliche Änderungen</strong> (z. B. Anpassungen von Hauptleistungs- oder Gegenleistungspflichten, Änderungen des Leistungsumfangs zum Nachteil des Nutzers) werden nur wirksam, wenn der Nutzer ihnen <strong>ausdrücklich zustimmt</strong>. Verweigert der Nutzer die Zustimmung oder reagiert er innerhalb der gesetzten Frist nicht, kann der Anbieter den Vertrag mit angemessener Frist kündigen; bis zum Wirksamwerden der Kündigung gelten die bisherigen AGB weiter.
      </p>
      <p>
        <strong>Unwesentliche Änderungen</strong> (z. B. redaktionelle Klarstellungen, Anpassungen an zwingendes Recht, neue Features ohne Nachteil) werden dem Nutzer mindestens 4 Wochen vor Inkrafttreten mitgeteilt. Widerspricht der Nutzer nicht innerhalb dieser Frist, gelten die Änderungen als akzeptiert. Der Anbieter weist in der Mitteilung ausdrücklich auf das Widerspruchsrecht und die Folgen eines Schweigens hin.
      </p>
      <p className="text-sm text-slate-500">
        Grundlage: BGH, Urteil vom 27.04.2022 – IV ZR 485/19 (Unwirksamkeit pauschaler Zustimmungsfiktionen bei wesentlichen Vertragsänderungen).
      </p>

      <hr />

      <h2>11. Urheberrecht und Nutzungsrechte</h2>

      <h3>11.1 Rechte des Anbieters</h3>
      <p>
        Alle Rechte an der App, Website, Design, Code, Logos und Inhalten liegen beim Anbieter. Der Nutzer erhält <strong>kein Eigentum</strong>, sondern nur ein <strong>nicht-exklusives, widerrufliches Nutzungsrecht</strong>.
      </p>

      <h3>11.2 Rechte des Nutzers</h3>
      <p>
        Der Nutzer behält alle Rechte an seinen hochgeladenen Inhalten (Ausgaben, Receipt-Fotos, Kommentare). Der Nutzer räumt dem Anbieter jedoch eine <strong>nicht-exklusive, weltweite Lizenz</strong> ein, diese Inhalte zu speichern und anzuzeigen (zur Erbringung des Dienstes).
      </p>

      <hr />

      <h2>12. Schlussbestimmungen</h2>

      <h3>12.1 Anwendbares Recht</h3>
      <p>
        Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
      </p>

      <h3>12.2 Gerichtsstand</h3>
      <p>
        Gerichtsstand ist Berlin (Sitz des Anbieters), sofern der Nutzer Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist.
      </p>

      <h3>12.3 Salvatorische Klausel</h3>
      <p>
        Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
      </p>

      <h3>12.4 Streitbeilegung</h3>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800 underline"
        >
          https://ec.europa.eu/consumers/odr
        </a>
      </p>
      <p>
        Wir sind <strong>nicht verpflichtet</strong> und <strong>nicht bereit</strong>, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <hr />

      <p className="text-sm text-slate-500 mt-8">
        <strong>Stand:</strong> 21. April 2026<br />
        <strong>Version:</strong> 1.3 — Anpassungen an aktuelle Rechtsprechung und Gesetzeslage. Neu: § 7.3 Aktualisierungspflicht nach § 327f BGB. Angepasst: § 6.3 Haftungsausschluss mit Rückbindung an §§ 309 Nr. 7 BGB und Kardinalpflichten; § 10.2 Zustimmungsfiktion BGH-konform aufgeteilt in wesentliche und unwesentliche Änderungen (BGH IV ZR 485/19).
      </p>

      <p className="text-sm text-slate-500">
        <strong>Kontakt bei Fragen:</strong><br />
        E-Mail: contact@equna.eu<br />
        Post: Patrizio Veglia, Herbststr. 9, 13409 Berlin, Germany
      </p>
    </>
  );
}
